import { ComponentRegisterDataModel } from '@osos/shared/types';

export class RegisterComponents {
  static readonly type = '[Component] Register Components';
  constructor(public payload: ComponentRegisterDataModel[]) {}
}

export class HandleInstalledPlugins {
  static readonly type = '[Plugins] Handle Installed Plugins';
  constructor(public payload: string[]) {}
}
